import { db } from "./db.js";
import { repository, RecordConflictError } from "./repository.js";
/** Only existing local IDs and guardian-authored questions are saved. No rendered medical summary. */
export async function saveVisitPreparation(input) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(input.fromDate) ||
        !/^\d{4}-\d{2}-\d{2}$/.test(input.toDate) ||
        input.fromDate > input.toDate ||
        new Set(input.factIds).size !== input.factIds.length ||
        input.factIds.length > 3 ||
        input.questions.length > 3)
        throw new Error("기간과 선택을 다시 확인해 주세요.");
    const start = Date.parse(input.fromDate + "T00:00:00Z"), end = Date.parse(input.toDate + "T00:00:00Z");
    if (!Number.isFinite(start) ||
        !Number.isFinite(end) ||
        new Date(start).toISOString().slice(0, 10) !== input.fromDate ||
        new Date(end).toISOString().slice(0, 10) !== input.toDate ||
        end - start > 369 * 86400000)
        throw new Error("관찰 기간은 실제 날짜로 370일 이내에서 골라 주세요.");
    const drafts = input.questions
        .map((row) => ({ ...row, text: row.text.trim() }))
        .filter((row) => row.text);
    if (drafts.some((row) => row.text.length > 500))
        throw new Error("질문은 한 문장에 500자까지 적어 주세요.");
    return db.transaction("rw", [db.pets, db.careQuestions], async () => {
        const pet = await repository.get("pets", input.petId);
        if (!pet || pet.deletedAt)
            throw new Error("아이 기록을 찾지 못했어요. 선택과 질문은 그대로예요.");
        if (pet.updatedAt !== input.expectedPetRevision)
            throw new RecordConflictError(pet);
        const questions = [];
        for (const draft of drafts) {
            const original = draft.id
                ? await repository.get("careQuestions", draft.id)
                : undefined;
            if (draft.id &&
                (!original ||
                    original.petId !== pet.id ||
                    original.deletedAt ||
                    original.answeredOn))
                throw new Error("질문 원본이 바뀌었어요. 지금 입력을 보관한 뒤 원본을 확인해 주세요.");
            if (original && draft.expectedUpdatedAt !== original.updatedAt)
                throw new RecordConflictError(original);
            questions.push(await repository.put("careQuestions", {
                ...original,
                petId: pet.id,
                text: draft.text,
                askedOn: original?.askedOn ??
                    new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Seoul" }).format(new Date()),
                relatedRecordIds: [...new Set(input.relatedRecordIds)],
                answeredOn: null,
                answer: null,
            }));
        }
        const saved = await repository.put("pets", {
            ...pet,
            visitPreparation: {
                fromDate: input.fromDate,
                toDate: input.toDate,
                factIds: input.factIds,
                questionIds: questions.map((row) => row.id),
            },
        });
        return { pet: saved, questions };
    });
}
